import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { api } from "../services/api";

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
      throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({children}) =>{
    const [user,setUser] = useState(localStorage.getItem('user')?localStorage.getItem('user'):null);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

    useEffect(()=>{
        if (token && user) {
            localStorage.setItem('token', token);
            setIsAuthenticated(true);
          } else {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
          }
    },[token]);

        const login = (token, userData) => {
            setToken(token);
            setUser(userData);
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem('token',token);
        };
    
        const logout = () => {
            setToken(null);
            setUser(null);
            localStorage.removeItem('refreshToken');
        };

        const initializeAuth = async(email,password) => {
          try {
            const response = await api.auth.authTokens({email,password});
            if(response?.data?.access_token) {
              localStorage.setItem('token',response?.data?.access_token);
              if(response?.data?.refresh_token){
                localStorage.setItem('refreshToken',response?.data?.refresh_token)
              }
              return true;
            }
            return false;
          } catch (error) {
            console.error('Failed to initialize authentication:', error);
            return false;
          }
        };
    
      const value = {
        user,
        token,
        isAuthenticated,
        login,
        logout,
        initializeAuth,
        setUser
      };
      return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
    AuthProvider.propTypes = {
        children: PropTypes.node.isRequired
    };

export default AuthContext;
  

